import { getResellerID } from '~/src/dash/resellers/utils/importResellerConfig';

export const appendResellerID = function (body: any) {
  return Object.assign({}, body, {
    reseller_id: getResellerID(),
  });
};
